import React, { useState } from "react";
import {
    Navbar,
    Nav,
    Container,
    Form,
    FormControl,
    Button,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaGlobe } from "react-icons/fa"; // ✅ Icon
import "./header.css";

const siteLogo = `${process.env.PUBLIC_URL}/img/Logo.png`;

const changeLanguage = (lang) => {
    const select = document.querySelector(".goog-te-combo");
    if (select) {
        select.value = lang;
        select.dispatchEvent(new Event("change"));
    }
};

const NewsHeader = () => {
    const [search, setSearch] = useState("");
    const navigate = useNavigate();

    const handleSearch = (e) => {
        e.preventDefault();
        if (!search.trim()) return;
        navigate(`/search?q=${encodeURIComponent(search)}`);
        setSearch("");
    };

    return (
        <>
            {/* Hidden Google Translate */}
            <div id="google_translate_element" style={{ display: "none" }} />

            <Navbar expand="lg" className="main-navbar sticky-top">
                <Container>
                    {/* Logo */}
                    <Navbar.Brand as={Link} to="/" className="brand-logo">
                        <img src={siteLogo} alt="Logo" className="header-logo" />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="news-navbar" />

                    <Navbar.Collapse id="news-navbar">
                        <Nav className="me-auto">
                            <Nav.Link as={Link} to="/politic">Politics</Nav.Link>
                            <Nav.Link as={Link} to="/business">Business</Nav.Link>
                            <Nav.Link as={Link} to="/technology">Technology</Nav.Link>
                            <Nav.Link as={Link} to="/sport">Sports</Nav.Link>
                            <Nav.Link as={Link} to="/entertainment">Entertainment</Nav.Link>
                            <Nav.Link as={Link} to="/health">Health</Nav.Link>
                            <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
                            <Nav.Link as={Link} to="/epaper">EPaper</Nav.Link>
                        </Nav>

                        <Nav className="align-items-center gap-3">
                            {/* Search */}
                            <Form className="d-flex header-search" onSubmit={handleSearch}>
                                <FormControl
                                    type="search"
                                    placeholder="Search news..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <Button type="submit" variant="danger">
                                    Search
                                </Button>
                            </Form>

                            {/* ✅ Language with Icon */}
                            <div className="language-dropdown d-flex align-items-center">
                                <FaGlobe className="globe-icon" />

                                <select
                                    className="lang-select"
                                    onChange={(e) => changeLanguage(e.target.value)}
                                    defaultValue="en"
                                >
                                    <option value="en">English</option>
                                    <option value="hi">Hindi</option>
                                    <option value="gu">Gujarati</option>
                                </select>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default NewsHeader;